<template>
    <div class="block-child">
        <img
            src="../assets/3-img.jpg"
            class="block-child__img"
        >
        <div class="image-caption image-caption--overlap-left">Двор-парк в&nbsp;проекте&nbsp;ПИК</div>

        <BlockParallax
            class="block-child__content"
            fixed
            speed="14"
            direction="top"
            transform="translateY"
        >
            <span class="block-child__title">Ребенок и мир</span>
            <p class="block-child__text">
                После уроков ребенку необходимо выпускать пар. Для этого подойдет любая физическая активность. Погонять мяч на стадионе возле школы, покататься на велике или скейте, полазить на площадке — что угодно.
            </p>
        </BlockParallax>
        <div class="block-child__road">
            <BlockParallax class="block-child__road__icon block-parents--icon-desktop" speed="15" transform="translateX" fixed>
                <img src="@/assets/images/icons/skate-1.png">
            </BlockParallax>
        </div>
    </div>
</template>

<script>
import BlockParallax from '@/components/blocks/parallax'

export default {
    components: {
        BlockParallax
    }
}
</script>

<style scoped lang="stylus">
    .block-child {
        margin-top 3rem
        margin-left -1rem
        margin-right -1rem
        font-size 0
        position relative

        +layout-sm-and-up() {
            margin-left 0
            margin-right 0
        }
        +layout-md-and-up() {
            margin-top 5rem
        }

        &__img {
            position relative
            z-index 4
            object-fit contain
            +layout-sm-and-up() {
                max-width 100%
            }

            +layout-xs() {
                width 100%
                height 355px
                object-fit cover
            }
        }

        &__content {
            position relative
            max-width 46rem
            background-color #66bd5a
            padding 2rem 2rem 3rem 2rem
            margin-left 4rem
            margin-top -10rem
            z-index 5
            +layout-sm-and-up() {
                margin-left auto
                margin-right 8rem
            }
            +layout-md-and-up() {
                padding 4rem 6rem
                padding-bottom 7rem
                margin -8rem 8rem 0 auto
                position relative
            }
        }

        &__title {
            font-size 2.2rem
            line-height 2.6rem
            font-weight $font-semiBold
            color $color-white
            +layout-md-and-up() {
                font-size 3rem
            }
        }

        &__text {
            color $color-text
            font-size 1.5rem
            line-height 1.47
            margin 1.6rem 0 0 0
        }

        &__icon {
            position absolute
        }

        &--icon-desktop {
            display none
            +layout-md-and-up() {
                display block
            }
        }

        &__icon-vane {
            z-index 100
            position absolute
            right -20px
            top -59px
            width 12rem
            height 12rem
            +layout-md-and-up() {
                right 0
                top -16.6rem
                width 20rem
                height 20rem
            }
        }

        &__road {
            display none
            +layout-md-and-up() {
                display block
                position absolute
                height 50rem
                background-image url('~@/assets/images/icons/612-bg-line.png')
                bottom -15rem
                width 100vw
                left 50%
                transform translateX(-50%)
                background-size 144rem auto
                background-repeat no-repeat
                background-position center top
            }
            @media (min-width: 1440px) {
                width 144rem
                left 50%
                background-position center top
            }
            &__icon {
                position absolute
                left 21%
                bottom 18.5rem
                img {
                    transform rotate(180deg)
                }
            }

        }
    }
</style>
